"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareManager = void 0;
var jszip_1 = __importDefault(require("jszip"));
var crc_32_1 = __importDefault(require("crc-32"));
var secure_dfu_1 = require("../../../lib/secure-dfu");
var fw_errors_enum_1 = require("./enum/fw-errors.enum");
var device_state_enum_1 = require("./enum/device-state.enum");
// eslint-disable-next-line import/prefer-default-export
var FirmwareManager = /** @class */ (function () {
    // eslint-disable-next-line no-undef
    function FirmwareManager(delay) {
        if (delay === void 0) { delay = 10; }
        this.debugMode = true;
        this.FwUpdateErrors = {
            // Invalid code
            0x00: 'Invalid opcode',
            // Success
            0x01: 'Operation successful',
            // Opcode not supported
            0x02: 'Opcode not supported',
            // Invalid parameter
            0x03: 'Missing or invalid parameter value',
            // Insufficient resources
            0x04: fw_errors_enum_1.FWErrorsEnum.ERROR_NOT_ENOUGH_MEMORY,
            // Invalid object
            0x05: fw_errors_enum_1.FWErrorsEnum.ERROR_PREVALIDATION,
            // Unsupported type
            0x07: 'Not a valid object type for a Create request',
            // Operation not permitted
            0x08: 'The state of the DFU process does not allow this operation',
            // Operation failed
            0x0a: 'Operation failed',
            // Extended error
            0x0b: fw_errors_enum_1.FWErrorsEnum.ERROR_POSTVALIDATION,
            // Low battery
            0x0c: fw_errors_enum_1.FWErrorsEnum.ERROR_FLAT_BATTERY,
            // Connection lost
            0x0d: fw_errors_enum_1.FWErrorsEnum.ERROR_BLE_LINK_LOSS,
            // Device disconnected
            0x0e: fw_errors_enum_1.FWErrorsEnum.ERROR_DEVICE_DISCONNECTED,
            // General
            0x0f: fw_errors_enum_1.FWErrorsEnum.ERROR_GENERAL
        };
        this.DFU = new secure_dfu_1.SecureDfu(crc_32_1.default.buf, this.bluetooth, delay);
    }
    // eslint-disable-next-line no-undef
    FirmwareManager.prototype.parsePackage = function (file) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var DfuPackage, manifest, _b, _c, initData, imageData, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, jszip_1.default.loadAsync(file)];
                    case 1:
                        DfuPackage = _d.sent();
                        if (DfuPackage === null)
                            throw new Error('[FirmwareManager] CANNOT READ PACKAGE');
                        _c = (_b = JSON).parse;
                        return [4 /*yield*/, DfuPackage.file('manifest.json').async('string')];
                    case 2:
                        manifest = (_a = _c.apply(_b, [_d.sent()])) === null || _a === void 0 ? void 0 : _a.manifest;
                        return [4 /*yield*/, DfuPackage.file(manifest === null || manifest === void 0 ? void 0 : manifest.application.dat_file).async('arraybuffer')];
                    case 3:
                        initData = _d.sent();
                        return [4 /*yield*/, DfuPackage.file(manifest === null || manifest === void 0 ? void 0 : manifest.application.bin_file).async('arraybuffer')];
                    case 4:
                        imageData = _d.sent();
                        this.firmwarePackage = {
                            manifest: manifest,
                            initFile: initData,
                            imageFile: imageData,
                        };
                        return [2 /*return*/, this.firmwarePackage];
                    case 5:
                        error_1 = _d.sent();
                        // PREVALIDATION ERRORS
                        this.DFU.setLastError(5);
                        throw error_1.message;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line no-undef
    FirmwareManager.prototype.update = function (batDevice, file, skipDfuMode) {
        var _a, _b, _c;
        if (skipDfuMode === void 0) { skipDfuMode = false; }
        return __awaiter(this, void 0, void 0, function () {
            var firmwarePackage, deviceDFU, updateResult, error_2, errorCode;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // eslint-disable-next-line no-useless-catch
                        this.DFU.setLastError(null);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, , 8]);
                        batDevice.setupConnectionConfig({
                            reconnectEnabled: false,
                        });
                        return [4 /*yield*/, this.parsePackage(file)];
                    case 2:
                        firmwarePackage = _d.sent();
                        if (!!skipDfuMode) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.DFU.setDfuMode(batDevice.getBleDevice(), {
                                service: batDevice.profile.DFU.uuid,
                                button: (_a = batDevice.profile.DFU.characteristics.filter(function (c) { return c.name === 'BUTTON_LESS'; })[0]) === null || _a === void 0 ? void 0 : _a.uuid,
                                control: (_b = batDevice.profile.DFU.characteristics.filter(function (c) { return c.name === 'CONTROL_POINT'; })[0]) === null || _b === void 0 ? void 0 : _b.uuid,
                                packet: (_c = batDevice.profile.DFU.characteristics.filter(function (c) { return c.name === 'DFU_PACKET'; })[0]) === null || _c === void 0 ? void 0 : _c.uuid,
                            })];
                    case 3:
                        _d.sent();
                        this.emitLog('device_state', device_state_enum_1.DeviceStateEnum.DFU_PROCESS_STARTED);
                        _d.label = 4;
                    case 4: return [4 /*yield*/, this.DFU.bluetooth.requestDevice({
                            filters: [{ services: [batDevice.profile.DFU.uuid] }],
                            optionalServices: [batDevice.profile.LOG.uuid, batDevice.profile.DFU.uuid],
                        })];
                    case 5:
                        deviceDFU = _d.sent();
                        return [4 /*yield*/, this.DFU.update(deviceDFU, firmwarePackage.initFile, firmwarePackage.imageFile, skipDfuMode)];
                    case 6:
                        updateResult = _d.sent();
                        this.emitLog('device_state', device_state_enum_1.DeviceStateEnum.DFU_COMPLETED);
                        return [2 /*return*/, updateResult];
                    case 7:
                        error_2 = _d.sent();
                        errorCode = this.DFU.getLastError();
                        switch (errorCode) {
                            case 4: //not enough memory
                            case 5: // pre validation
                            case 11: //post validation
                                break;
                            case 14: // device disconnected
                                this.emitLog('device_state', device_state_enum_1.DeviceStateEnum.DFU_COMPLETED);
                                break;
                            case null: // link loss
                                errorCode = 13;
                                break;
                            default: //general error
                                errorCode = 15;
                                break;
                        }
                        this.emitLog('fwerror', this.FwUpdateErrors[errorCode]);
                        throw error_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    FirmwareManager.prototype.getDFU = function () {
        return this.DFU;
    };
    FirmwareManager.prototype.createEvent = function (type, detail) {
        if (detail === void 0) { detail = {}; }
        return new CustomEvent(type, {
            detail: detail,
            bubbles: true,
            cancelable: true,
            composed: false,
        });
    };
    FirmwareManager.prototype.dispatchEvent = function (eventType, detail) {
        var event = this.createEvent(eventType, detail);
        document.dispatchEvent(event);
    };
    FirmwareManager.prototype.emitLog = function (type, message) {
        this.log(message);
        if (typeof message === 'string') {
            message = { message: message };
        }
        this.dispatchEvent(type, message);
    };
    FirmwareManager.prototype.log = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (this.debugMode) {
            console.log.apply(console, message);
        }
    };
    return FirmwareManager;
}());
exports.FirmwareManager = FirmwareManager;
